<template>
  <div class="room_flex">
    <div class="room_dp_panel">
      <date-picker-no-icon :getDate="setDataValue" @getTimes="setCheckDate"></date-picker-no-icon>
    </div>
    <div class="room_pn_panel">
      <Guests :roomCount="roomNum" :guestCount="guestNum" :showIcon="false"></Guests>
    </div>
  </div>
</template>

<script>
import DatePickerNoIcon from "../components/DatePickerNoIcon.vue";
import Guests from "../components/Guests.vue";
export default {
  name: "DateRoom",
  components: {
    DatePickerNoIcon,
    Guests,
  },
  props: {
    setDataValue: {},
    roomNum: { default: 1 },
    guestNum: { default: 1 },
  },
  data() {
    return {
      value: "",
      cities: [
        {
          value: "Beijing",
          label: "北京",
        },
        {
          value: "Shanghai",
          label: "上海",
        },
        {
          value: "Nanjing",
          label: "南京",
        },
        {
          value: "Chengdu",
          label: "成都",
        },
        {
          value: "Shenzhen",
          label: "深圳",
        },
        {
          value: "Guangzhou",
          label: "广州",
        },
      ],
      data_value: "",
    };
  },
  methods: {
    // 入 离 时间组件返回信息
    setCheckDate() {},
  },
};
</script>

<style lang="stylus" scoped>
/* 手机、平板屏幕 */
@media screen and (max-width: 960px) {
  .room_flex {
    display: unset;
    margin: 2rem 1rem;
  }

  .room_dp_panel {
    width: unset;
    margin-right: 0rem;
    margin-bottom: 1rem;
  }

  .room_pn_panel {
    flex: 1;
  }

  .dp_no_icon ::v-deep .el-input__wrapper{
    height: 5rem;
    line-height: 5rem;
    background-color: #E7E9EA;
  }

  ::v-deep .el-range-editor .el-range-input {
    background-color: #E7E9EA;
  }
}
/* 电脑屏幕 */
@media screen and (min-width: 961px) {
  .room_flex {
    display: flex;
    margin: 2rem 1rem;
  }

  .room_dp_panel {
    width: 65%;
    margin-right: 1.3rem;
  }

  .room_pn_panel {
    flex: 1;
  }

  .dp_no_icon ::v-deep .el-input__wrapper{
    height: 5rem;
    line-height: 5rem;
    background-color: #E7E9EA;
  }

  ::v-deep .el-range-editor .el-range-input {
    background-color: #E7E9EA;
  }
}
</style>
